import { render, staticRenderFns } from "./forget-pass.vue?vue&type=template&id=1b9752d2&scoped=true&"
import script from "./forget-pass.vue?vue&type=script&lang=js&"
export * from "./forget-pass.vue?vue&type=script&lang=js&"
import style0 from "./forget-pass.vue?vue&type=style&index=0&id=1b9752d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b9752d2",
  null
  
)

export default component.exports